import { useState } from 'react';
import { Mediator } from '@spotahome/soyuz-mediator';
import Metrics from '@spotahome/soyuz-metrics';

import { addFavorite, removeFavorite } from '@gqlClient/mutations/favorites';
import getGqlClient from '@gqlClient/client';

import { OPEN_FAVORITE_CLAIM } from '@common/channels';
import { useIsUserLoggedContext } from '@common/context/IsUserLoggedContext';

const noOp = () => {};

const markAsFavorite = async (id, isLogged) => {
  await addFavorite(getGqlClient())(id);

  if (!isLogged) {
    Mediator.publish(OPEN_FAVORITE_CLAIM);
  }

  Metrics.ga.sendEvent('favorite-button', 'enable-click');
};

const unmarkAsFavorite = async id => {
  await removeFavorite(getGqlClient())(id);

  Metrics.ga.sendEvent('favorite-button', 'disable-click');
};

const useFavorite = (id, isInitialFavorite, onToggleFavorite = noOp) => {
  const { isUserLogged } = useIsUserLoggedContext();
  const [isFavorite, setIsFavorite] = useState(isInitialFavorite);

  const toggleFavorite = async () => {
    if (!id) {
      console.error('Can not toggle a favorite without an id');
      return;
    }
    const newIsFavorite = !isFavorite;
    setIsFavorite(newIsFavorite);

    try {
      const action = newIsFavorite ? markAsFavorite : unmarkAsFavorite;
      await action(id, isUserLogged);
      onToggleFavorite(id, newIsFavorite);
    } catch (error) {
      console.error(error);
      setIsFavorite(!newIsFavorite);
    }
  };

  return { isFavorite, toggleFavorite };
};

export default useFavorite;
